import { Helmet } from 'react-helmet-async'
import { useIntl } from 'react-intl'
import { View } from 'react-native'
import styled from 'styled-components'
import { MaxWidthView } from '@flix/common/elements/layout'
import { H1, H2, H3, Paragraph } from '@flix/common/elements/typography'
import { media } from '@flix/common/style/media'
import { canonicalUrl } from '../../../utils/htmlHead'
import meta from '../../metaDescriptions'

const P = styled(Paragraph)`
  ${media.sm`
    width: 70%;
  `};
`

const JobTitle = styled(H2)`
  margin-top: ${(props) => props.theme.spacing.large}px;
  padding-top: ${(props) => props.theme.spacing.larger}px;
  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: ${(props) => props.theme.colors.grayLight};
`

const Location = styled(H3)`
  margin-top: ${(props) => props.theme.spacing.small}px;
`

const SubHead = styled(H3)`
  margin-top: ${(props) => props.theme.spacing.medium}px;
  margin-bottom: ${(props) => props.theme.spacing.smedium}px;
`

const CareersPage = ({ location }) => {
  const intl = useIntl()
  return (
    <MaxWidthView alignItems="stretch" style={{ marginBottom: 70 }}>
      <Helmet>
        <title>{intl.formatMessage(meta.careersTitle)}</title>
        <meta property="og:title" content="Careers at Flix Premiere" />
        <meta
          name="description"
          property="og:description"
          content={intl.formatMessage(meta.careers)}
        />
        <meta property="og:url" content={canonicalUrl(location)} />
        <link rel="canonical" href={canonicalUrl(location)} />
      </Helmet>

      <H1 mt="larger" mb="larger">
        Careers
      </H1>

      <View>
        To apply, send your CV and cover letter to{' '}
        <a
          href="mailto:careers@flixpremiere.com"
          target="_blank"
          rel="noopener noreferrer"
          className="underline"
        >
          careers@flixpremiere.com
        </a>
      </View>

      <View>
        <JobTitle>Head of Infrastructure Engineering</JobTitle>

        <SubHead>Country: USA</SubHead>

        <Location>City: New York</Location>

        <SubHead>Background:</SubHead>
        <P>
          Responsible for the core server infrastructure running the application microservices as
          well as supporting services in the USA. The US Head of Infrastructure Engineering will
          work with the VP of Engineering on the design and implementation of the technical
          architecture for hosting and maintains the Continuous Integration and Delivery pipelines
          to ensure the effective functioning of the development team.
        </P>

        <SubHead>Responsibilities</SubHead>
        <ul>
          <li>
            Owner of the Flix Premiere enterprise streaming platform server infrastructure running
            the application microservices in the USA.
          </li>
          <li>Implementation and monitoring of CI/CD pipelines.</li>
          <li>System monitoring of all US services.</li>
          <li>Development of the server-side microservices along with the development team.</li>
          <li>Region specific data infrastructure and query optimisation.</li>
        </ul>

        <SubHead>Skills:</SubHead>
        <ul>
          <li>10+ years' development and DevOps experience</li>
          <li>Docker and Kubernetes experience</li>
          <li>System architect</li>
          <li>Keen thinker, and researcher</li>
          <li>Excellent communication skills</li>
        </ul>
      </View>
    </MaxWidthView>
  )
}

export default CareersPage
